import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '@/services/api';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { admin, token } = await adminApi.login(username, password);
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_user', JSON.stringify(admin));
      navigate('/admin');
    } catch (err) {
      setError(err instanceof Error ? err.message : '账号或密码错误');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-foreground-950 text-white mb-4">
            <i className="ri-shield-check-line text-2xl" />
          </div>
          <h1 className="text-xl font-semibold text-foreground-950">绿证通管理后台</h1>
          <p className="text-sm text-foreground-500 mt-1">请使用管理员账号登录</p>
        </div>

        {/* Form card */}
        <form onSubmit={handleSubmit} className="bg-white rounded-xl p-6 border border-background-200">
          {error && (
            <div className="flex items-center gap-2 p-3 mb-4 rounded-lg bg-red-50 text-red-700 text-sm">
              <i className="ri-error-warning-line" />
              {error}
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">
              管理员账号
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400">
                <i className="ri-user-line text-sm" />
              </span>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="请输入管理员账号"
                className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-foreground-400 focus:ring-1 focus:ring-foreground-400 transition-colors"
                required
              />
            </div>
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-foreground-700 mb-1.5">
              密码
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400">
                <i className="ri-lock-line text-sm" />
              </span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="请输入密码"
                className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-foreground-400 focus:ring-1 focus:ring-foreground-400 transition-colors"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2.5 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
              loading
                ? 'bg-foreground-300 text-white cursor-not-allowed'
                : 'bg-foreground-950 text-white hover:bg-foreground-800'
            }`}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <i className="ri-loader-4-line animate-spin" />
                验证中...
              </span>
            ) : (
              '登 录'
            )}
          </button>
        </form>

        <button
          onClick={() => navigate('/')}
          className="mt-6 mx-auto flex items-center gap-1.5 text-sm text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line" />
          返回前台首页
        </button>
      </div>
    </div>
  );
}
